// extracted by mini-css-extract-plugin
export default {"segmented":"segmented-tabs_segmented__rwiEG","indicator":"segmented-tabs_indicator__1qfHf","option":"segmented-tabs_option__FQ-8N"};